export var SELECT_EVENT_COLLECTION = '@query-creator/SELECT_EVENT_COLLECTION';
export var SELECT_ANALYSIS = '@query-creator/SELECT_ANALYSIS';
export var SET_QUERY_EVENT = '@query-creator/set-query';
export var NEW_QUERY_EVENT = '@query-creator/new-query';
export var SET_CHART_SETTINGS = '@query-creator/set-chart-settings';
export var UPDATE_VISUALIZATION_TYPE = '@query-creator/UPDATE_VISUALIZATION_TYPE';
export var DEFAULT_ANALYSIS = 'count';
export var UPDATE_TIMEOUT = 0;
export var QUERY_UPDATE_ACTION = '@query';
export var ANALYTICS_API_HOST = 'ANALYTICS_API_HOST';
export var TIMEZONES_API_HOST = 'TIMEZONES_API_HOST';
export var HTTP_PROTOCOL = 'HTTP_PROTOCOL';
export var SCHEMA_PROPS = {
  num: 'Number',
  string: 'String',
  bool: 'Boolean',
  datetime: 'Datetime',
  null: 'String',
  list: 'List',
  geo: 'Geo',
  array: 'List'
};
export var ABSTRACT_OPERATORS = ['is_null', 'is_not_null'];
export var ANALYSIS_TYPES = ['average', 'count', 'count_unique', 'extraction', 'funnel', 'maximum', 'median', 'minimum', 'percentile', 'select_unique', 'standard_deviation', 'sum'];
export var TIME_UNITS = {
  minute: 'minutes',
  hour: 'hours',
  day: 'days',
  week: 'weeks',
  month: 'months',
  year: 'years'
};
export var TOOLTIP_MOTION = {
  transition: {
    duration: 0.3
  },
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
};